<template>
  <label class="chip"
         :class="classes">
    <input type="checkbox"
           v-model="isChecked"
           :disabled="disabled"
           @change="onChange"
           @focus="onFocus"
           @blur="onBlur" />

    <div v-if="isChecked" class="checkmark"></div>
    
    <div class="label one-liner" v-if="label || $slots.default">
      <slot>{{ label }}</slot>
    </div>
  </label>
</template>

<script>
  export default {
    model: {
      prop: 'value',
      event: 'input'
    },

    props: {
      value: {
        required: true,
        type: Boolean
      },

      label: {
        required: false,
        type: String
      },

      disabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isChecked: this.value
      }
    },

    methods: {
      onChange() {
        this.$emit('input', this.isChecked)
      },

      onFocus(event) {
        this.isActive = true
        this.$emit('focus', event)
      },

      onBlur(event) {
        this.isActive = false
        this.$emit('blur', event)
      }
    },

    computed: {
      classes() {
        return {
          'active': this.isChecked
        }
      }
    },

    watch: {
      value: {
        handler: function(value) {
          this.isChecked = !!value
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
$checkmark-size: 18px;

.chip {
  height: 28px;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  padding: 0 10px;
  user-select: none;

  cursor: pointer;
  color: #3E3A3B;
  background-color: #fff;
  border-radius: 60px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.199574);


  input {
    display: none;
  }

  &.active {
    padding: 0 10px 0 5px;
    color: #fff;
    background-color: map.get($colors, primary);
  }

  &:focus {
    color: #fff;
    background-color: map.get($colors, primary);
  }

  &:active:focus{
    background-color: map.get($colors, primary);  
  }

  .label {
    min-width: 0;
    max-width: 150px;
    display: inline-block;
  }

  .checkmark {
    position: relative;
    flex-shrink: 0;
    margin-right: 5px;

    width: $checkmark-size;
    height: $checkmark-size;

    background: transparent;
    transition: all .1s ease-out;
  }

  .checkmark::after {
    content: '';
    position: absolute;
    top: 45%;
    left: 60%;
    display: block;
    width: 30%;
    height: 70%;
    transform: translate(-45%, -60%) rotate(45deg);
    border: solid #fff;
    border-width: 0 calc($checkmark-size / 10) calc($checkmark-size / 10) 0;
    transition: all .1s ease-out;
    opacity: 1;
  }
}
</style>